<template>
    <div
        class="deepi-base-field"
    >
        <label
            v-if="props.label"
            v-title-clamp
            class="text-body-s text-medium text-ellipsis"
            :class="labelClasses"
			:htmlFor="props.id ?? props.label?.replace(/\s+/g, '-').toLowerCase()"
        >
            {{ props.label }}{{ isRequired ? ' *' : '' }}
		</label>
        <slot />
        <div
            v-if="hasDetails"
            class="deepi-base-field-details"
        >
            <p
                v-if="props.hint && props.isValid"
                v-title-clamp
                class="text-body-s text-medium text-secondary-300 text-ellipsis"
            >
                {{ props.hint }}
            </p>
            <p
                v-if="!props.isValid"
                v-title-clamp
                class="text-body-s text-medium text-error text-ellipsis"
            >
                {{ errorMessage }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface DeepiBaseFieldProps {
    id?: string;
    label?: string;
    hint?: string;
    hasFocus?: boolean;
    isValid?: boolean;
    forceDetails?: boolean;
    rules?: ((value: any) => boolean | string)[];
    errorMessages?: string | readonly string[];
};

const props = withDefaults(defineProps<DeepiBaseFieldProps>(), {
    isValid: true
});

const isRequired = computed((): boolean => {
    return props.rules?.some(r => (r as any).name.includes('required')) ?? false;
});

const hasDetails = computed((): boolean => {
    return !!(props.hint || props.rules?.length || props.forceDetails);
});

const labelClasses = computed((): string[] => {
    const classes: string[] = [];
    if (!props.hasFocus && props.isValid) {
        classes.push('text-secondary-500');
    }
    if (props.hasFocus) {
        classes.push('text-primary');
    }
    if (!props.isValid) {
        classes.push('text-error');
    }
    return classes;
});

const errorMessage = computed((): string => {
    if (props.isValid || !props.errorMessages || !props.errorMessages[0]) {
        return '';
    }
    return props.errorMessages[0];
});
</script>

<style scoped lang="scss">
@use 'DeepiBaseField.scss';
</style>